import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=76c4c54c&scoped=true"
import script from "./CatalogCard.vue?vue&type=script&lang=ts"
export * from "./CatalogCard.vue?vue&type=script&lang=ts"
import style0 from "./CatalogCard.vue?vue&type=style&index=0&id=76c4c54c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c4c54c",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QSkeleton,QCardSection,QIntersection,QIcon});
